'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _account = require('./account');

var _account2 = _interopRequireDefault(_account);

var _authorization = require('./authorization');

var _authorization2 = _interopRequireDefault(_authorization);

var _brand = require('./brand');

var _brand2 = _interopRequireDefault(_brand);

var _category = require('./category');

var _category2 = _interopRequireDefault(_category);

var _checkout = require('./checkout');

var _checkout2 = _interopRequireDefault(_checkout);

var _common = require('./common');

var _common2 = _interopRequireDefault(_common);

var _discount = require('./discount');

var _discount2 = _interopRequireDefault(_discount);

var _fastOrder = require('./fast-order');

var _fastOrder2 = _interopRequireDefault(_fastOrder);

var _home = require('./home');

var _home2 = _interopRequireDefault(_home);

var _layout = require('./layout');

var _layout2 = _interopRequireDefault(_layout);

var _news = require('./news');

var _news2 = _interopRequireDefault(_news);

var _help = require('./help');

var _help2 = _interopRequireDefault(_help);

var _product = require('./product');

var _product2 = _interopRequireDefault(_product);

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

var _seller = require('./seller');

var _seller2 = _interopRequireDefault(_seller);

var _error = require('./error');

var _error2 = _interopRequireDefault(_error);

var _vaccines = require('./vaccines');

var _vaccines2 = _interopRequireDefault(_vaccines);

var _reservationCampaign = require('./reservation-campaign');

var _reservationCampaign2 = _interopRequireDefault(_reservationCampaign);

var _outlet = require('./outlet');

var _outlet2 = _interopRequireDefault(_outlet);

var _rental = require('./rental');

var _rental2 = _interopRequireDefault(_rental);

var _certificates = require('./certificates');

var _certificates2 = _interopRequireDefault(_certificates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import staticModule from './static';

var _module = _angular2.default.module('app.features', [_account2.default, _authorization2.default, _brand2.default, _category2.default, _checkout2.default, _common2.default, _discount2.default, _fastOrder2.default, _home2.default, _layout2.default, _news2.default, _product2.default, _search2.default, _seller2.default,
//staticModule,
_vaccines2.default, _reservationCampaign2.default, _error2.default, _help2.default, _outlet2.default, _rental2.default, _certificates2.default]);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/index.js
// module id = 257
// module chunks = 0